import React from 'react'
import { Container, Table } from 'semantic-ui-react'
import { tr } from '../../../helpers/languages'

const EducationalContent = (props) => {
    return props.educationalContent ? (
        <Container className='exercises'>
            <Table fixed singleLine>
                <Table.Body>
                    {
                        props.educationalContent.map((content, index) => {
                            const status = content.isCompleted ? tr('COMPLETED')
                                : tr('NOT_COMPLETED')
                            return (
                                <Table.Row
                                    key={`educational-content${content.id}`}
                                    className={index === props.educationalContent.length - 1 ? 'last' : ''}
                                >
                                    <Table.Cell className='name'>
                                        {<span>{content.title}</span>}
                                    </Table.Cell>
                                    <Table.Cell className={`status ${content.isCompleted ? 'target_completed' : 'no_progress'}`}>
                                        {status}
                                    </Table.Cell>
                                </Table.Row>
                            )
                        })
                    }
                </Table.Body>
            </Table>
        </Container>
    ) : null
}

export default EducationalContent



// WEBPACK FOOTER //
// ./src/components/common/completed-educational-content/educational-content.js